import { render, staticRenderFns } from "./ShowFeedbackRequest.vue?vue&type=template&id=de613ed0"
import script from "./ShowFeedbackRequest.vue?vue&type=script&lang=js"
export * from "./ShowFeedbackRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports